import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Initiates authentication once as soon as the effect is registered
 */
export const startAuth = store.effects.create((feature: Feature) =>
  rxjs.of(feature.actions.authenticate.from('startAuth (effect)').create()),
)
